/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * setSwiper.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * __00: 初期設定
 **━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
import Swiper from "swiper/bundle";
import "swiper/css/bundle";

export function setSwiper() {
    const swiperBnr = document.querySelector('.swiper-bnr');
    const init = { loop: true, speed: 1000 }

    if (swiperBnr) {
        /**
         * @name options
         * @description swiperのオプション
         */
        let options = {
            ...init,
            autoplay: { disableOnInteraction: false, delay: 2000, },
            slidesPerView: "auto",
            spaceBetween: 30,
            navigation: {
                nextEl: '.top-bnr-tool-button.next',
                prevEl: '.top-bnr-tool-button.prev',
            },
        }
        const swiper = new Swiper(swiperBnr, Object.assign(options));
    }
}